import React from 'react'
import * as Request from '../../utilities/request'
import { AppContext } from '../../App'
import { InvoiceHistory } from '../../../../back-end/common/invoiceHistory'
import { Accordion, Col, Row } from 'react-bootstrap'
import { Loading } from '../ui/Loading/Loading'
import { DateTime } from 'luxon'

interface InvoiceHistoryCardProps {
	invoiceID: string
}

const InvoiceHistoryCard = (props: InvoiceHistoryCardProps) => {
	const { appState } = React.useContext(AppContext)

	const [invoiceHistory, setInvoiceHistory] = React.useState<InvoiceHistory[] | null>(null)

	const onCardOpen = async () => {
		if (!appState.authState.isLoggedIn || invoiceHistory) {
			return
		}

		const invoiceHistoryRes = await Request.get(`invoicehistory/${props.invoiceID}`)
		setInvoiceHistory(invoiceHistoryRes.data.invoiceHistory)
	}

	return (
		<Accordion>
			<Accordion.Item eventKey="0">
				<Accordion.Header onClick={onCardOpen}>Invoice History</Accordion.Header>
				<Accordion.Body>
					<Row>
						<Col sm={2}>
							<span className="span-body-1 span-black span-bold">User/Date</span>
						</Col>
						<Col sm={2}>
							<span className="span-body-1 span-black span-bold">Invoice Change</span>
						</Col>
					</Row>
					{invoiceHistory ? (
						invoiceHistory.map((ih, index) => (
							<Row key={index} className="border-top">
								<Col sm={2} className="d-flex flex-column">
									<span className="span-body-2 span-black span-bold">{`${ih.createUser.firstName} ${ih.createUser.lastName}`}</span>
									<span className="span-body-2 span-black">
										{DateTime.fromISO(ih.createTs).setLocale('en-AU').toLocaleString(DateTime.DATETIME_SHORT)}
									</span>
								</Col>
								<Col sm={10}>
									<div className="d-block span-body-2 span-black pre-line">{ih.description.replaceAll(';', '\n')}</div>
								</Col>
							</Row>
						))
					) : (
						<div className="center-flex p-5">
							<Loading show />
						</div>
					)}
				</Accordion.Body>
			</Accordion.Item>
		</Accordion>
	)
}

export default InvoiceHistoryCard
